// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ProjectsCaseStudiesPage from "../pages/ProjectsCaseStudies/ProjectsCaseStudies";
const __wvcRoutePaths = ["/ProjectsCaseStudiesPage", "/projects"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "about-us", "aboutbmfpage", "accreditations", "air-conditioning-hvac-contractors", "airconditioninghvaccontractorspage", "areas-we-cover", "areaswecoverpage", "chimney-scaffolding", "chimneyscaffoldingpage", "commercial", "commercialscaffoldingpage", "contactrequestquotepage", "councils-public-sector", "councilsandpublicsectorpage", "data-centres", "datacentrespage", "demolition-contractors", "demolitioncontractorspage", "edge-protection", "edgeprotectionpage", "faqpage", "healthsafetyaccreditationspage", "heritage-listed-buildings", "heritageandlistedbuildingspage", "home", "homepage", "industrial-scaffolding", "industrialscaffoldingpage", "main-contractors-developers", "maincontractorsdeveloperspage", "new-build-scaffolding", "newbuildscaffoldingpage", "post", "projects", "projectscasestudiespage", "property-facilities-management", "propertyfacilitiesmanagementpage", "q-a-faqs", "refurbishment-scaffolding", "refurbishmentscaffoldingpage", "request-quote", "residential", "residentialscaffoldingpage", "roofing", "roofing-contractors", "roofingcontractorspage", "roofingscaffoldingpage", "scaffolding-in-aldershot", "scaffolding-in-amersham", "scaffolding-in-andover", "scaffolding-in-ascot", "scaffolding-in-aylesbury", "scaffolding-in-basingstoke", "scaffolding-in-beaconsfield", "scaffolding-in-bracknell", "scaffolding-in-camberley", "scaffolding-in-clapham", "scaffolding-in-epsom", "scaffolding-in-farnborough", "scaffolding-in-farnham", "scaffolding-in-fleet", "scaffolding-in-gerrards-cross", "scaffolding-in-guildford", "scaffolding-in-high-wycombe", "scaffolding-in-kingston-upon-thames", "scaffolding-in-maidenhead", "scaffolding-in-marlow", "scaffolding-in-milton-keynes", "scaffolding-in-newbury", "scaffolding-in-reading", "scaffolding-in-redhill", "scaffolding-in-richmond", "scaffolding-in-slough", "scaffolding-in-wandsworth", "scaffolding-in-weybridge", "scaffolding-in-winchester", "scaffolding-in-windsor", "scaffolding-in-woking", "scaffolding-in-wokingham", "scaffolding-services", "scaffoldinginaldershotpage", "scaffoldinginamershampage", "scaffoldinginandoverpage", "scaffoldinginascotpage", "scaffoldinginaylesburypage", "scaffoldinginbasingstokepage", "scaffoldinginbeaconsfieldpage", "scaffoldinginbracknellpage", "scaffoldingincamberleypage", "scaffoldinginclaphampage", "scaffoldinginepsompage", "scaffoldinginfarnboroughpage", "scaffoldinginfarnhampage", "scaffoldinginfleetpage", "scaffoldingingerrardscrosspage", "scaffoldinginguildfordpage", "scaffoldinginhighwycombepage", "scaffoldinginkingstonuponthamespage", "scaffoldinginmaidenheadpage", "scaffoldinginmarlowpage", "scaffoldinginmiltonkeynespage", "scaffoldinginnewburypage", "scaffoldinginreadingpage", "scaffoldinginredhillpage", "scaffoldinginrichmondpage", "scaffoldinginsloughpage", "scaffoldinginwandsworthpage", "scaffoldinginweybridgepage", "scaffoldinginwinchesterpage", "scaffoldinginwindsorpage", "scaffoldinginwokinghampage", "scaffoldinginwokingpage", "scaffoldingservicespage", "search", "solar-access", "solar-installers", "solarinstallerspage", "solarscaffoldingpage", "specialist-access-scaffolding", "specialistaccessscaffoldingpage", "temporary-roofs", "temporaryroofspage", "testimonials", "testimonialspage", "thank-you", "thankyoupage", "who-we-work-with", "whoweworkwithpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ProjectsCaseStudiesPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ProjectsCaseStudiesPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
